<template>
  <button
    class="justify-self-center border-light-gray border justify-center rounded-full text-center py-3 px-7 md:px-8 text-small items-center transition-all duration-500 break-words focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary;"
    :disabled="disabled"
    :class="[
      disabled || disabledVisible
        ? 'bg-secondary text-mid-gray transition'
        : 'bg-bkk-50 text-mid-gray hover:bg-bkk-75 cursor-pointer',
    ]"
  >
    {{ label }}
  </button>
</template>
<script setup lang="ts">
defineProps({
  label: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  disabledVisible: {
    type: Boolean,
    default: false,
  },
  functionDisabled: {
    type: Boolean,
    default: false,
  },
});
</script>
